/*
 * This is where settings variables will be stored.
 */

export const DEFAULT_PARCEL_ID = '0028F00194000000';


// DEFAULT STYLES
export const themeColors = {
  black: '#242424',
  yellow: '#F69B00',
  white: '#E1E1E1',
  gray: '#A5B5B7'
};


// WEBPACK FOOTER //
// ./src/utils/settings.js